const SESSION_KEY = 'hiray_analytics_session';
const SESSION_LANDED_KEY = 'hiray_analytics_landed';

function getApiBase() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return '';
    }
  }
  return 'https://manager.hirayind.com';
}

function genId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }
  return `${Date.now()}${Math.random().toString(16).slice(2)}`;
}

function getSessionId() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = genId();
    sessionStorage.setItem(SESSION_KEY, id);
    sessionStorage.removeItem(SESSION_LANDED_KEY);
  }
  return id;
}

function isLandingVisit() {
  if (sessionStorage.getItem(SESSION_LANDED_KEY)) return 0;
  sessionStorage.setItem(SESSION_LANDED_KEY, '1');
  return 1;
}

let pageStartMs = Date.now();
let currentVisitToken = null;

function buildQuery(params) {
  return Object.keys(params)
    .filter(k => params[k] != null && params[k] !== '')
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
}

function sendDuration() {
  if (!currentVisitToken) return;
  const durationSec = Math.min(86400, Math.max(0, Math.round((Date.now() - pageStartMs) / 1000)));
  const qs = buildQuery({ VisitToken: currentVisitToken, DurationSec: durationSec });
  const url = `${getApiBase()}/Api/SiteVisit/TrackDuration?${qs}`;
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url);
  } else {
    fetch(url, { mode: 'cors', keepalive: true }).catch(() => {});
  }
  currentVisitToken = null;
}

function trackPage(route) {
  pageStartMs = Date.now();
  const sessionId = getSessionId();
  const query = route.query ? new URLSearchParams(route.query).toString() : '';
  const params = {
    SessionId: sessionId,
    PagePath: route.path || '/',
    PageQuery: query,
    PageTitle: typeof document !== 'undefined' ? document.title : '',
    Referrer: typeof document !== 'undefined' ? document.referrer : '',
    Language: typeof navigator !== 'undefined' ? navigator.language : '',
    ScreenSize: typeof window !== 'undefined' ? `${window.screen.width}x${window.screen.height}` : '',
    SiteHost: typeof window !== 'undefined' ? window.location.host : '',
    IsLanding: isLandingVisit()
  };
  const url = `${getApiBase()}/Api/SiteVisit/TrackPage?${buildQuery(params)}`;
  fetch(url)
    .then(res => res.json())
    .then(data => {
      const payload = data && data.data ? data.data : data;
      if (payload && payload.visitToken) {
        currentVisitToken = payload.visitToken;
        if (payload.sessionId) sessionStorage.setItem(SESSION_KEY, payload.sessionId);
      }
    })
    .catch(() => {});
}

export function initSiteAnalytics(router) {
  router.beforeEach((to, from, next) => {
    if (from && from.path) sendDuration();
    next();
  });

  router.afterEach(to => {
    trackPage(to);
  });

  if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', sendDuration);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') sendDuration();
    });
  }
}
